<template>
  <div>
    <b-row>
      <PaymentTypeBox
        v-for="option in paymentOptions"
        :key="option.value"
        v-model="methodType"
        :innerValue="option.value"
        :label="option.label"
        :description="option.description"
        :operator="option.operator"
      />
    </b-row>
  </div>
</template>

<script setup lang="ts">
import PaymentTypeBox from '@/components/formOfPayment/PaymentType.vue'
import useTransactionDataStore from '@/stores/transactionData'
import { PaymentMethod } from '@/types'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

const transactionDataStore = useTransactionDataStore()
const { methodType } = storeToRefs(transactionDataStore)

const { t } = useI18n()

const paymentOptions = [
  {
    value: PaymentMethod.online,
    label: t('form.formOfPayment.online.label'),
    description: t('form.formOfPayment.online.description'),
    operator: true
  },
  {
    value: PaymentMethod.traditional,
    label: t('form.formOfPayment.traditional.label'),
    description: t('form.formOfPayment.traditional.description'),
    operator: false
  }
]
</script>
